import React from 'react';
import { ButtonGroup } from '@mui/material'
import ShopRoundedIcon from '@mui/icons-material/ShopRounded';
import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import { addToCart, cartData } from '../../features/cart/cartSlice';
import { previousCart } from '../../driver';
import { useGetproductsQuery } from '../../features/api/apiSlice';
export default function AddtoCart({ id, counter, setSnackPack }) {

    const { data: products } = useGetproductsQuery()

    const dispatch = useDispatch()
    const handleAddToCart = () => {
        const message = 'Item added to Cart'
        setSnackPack((prev) => [...prev, { message, key: new Date().getTime() }]);
        dispatch(addToCart({ id, counter }));
        dispatch(cartData(previousCart(products)));
    }

    return (
        <div className="row">
            <div className="col btn-block">
                <ButtonGroup variant="contained" aria-label="outlined primary button group">
                    <button className="btn add-cart-btn "
                        style={{ marginRight: '5px', fontWeight: 'bold' }}
                        onClick={() => handleAddToCart()}
                        disabled={counter === 0 ? true : false}

                    >{

                            <p className='p-0 m-0'><ShoppingCartRoundedIcon /> Add to cart</p>
                            // :
                            // <Link className='text-whtie' to="/reviewList"> <ShoppingCartRoundedIcon /> GO TO CART</Link>
                        }
                    </button>
                    <button className="btn add-cart-btn" style={{ fontWeight: 'bold' }}>
                        <Link className='text-white' to="/reviewList">
                            <ShopRoundedIcon /> Buy Now
                        </Link>
                    </button>

                </ButtonGroup>

            </div>
        </div>
    )
}
